import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { GlobalMessageComponent, IconModule } from '@spartacus/storefront';

@Component({
  standalone: true,
  selector: 'cx-global-message',
  templateUrl: './custom-global-message.component.html',
  imports: [CommonModule, IconModule, I18nModule],
})
export class CustomGlobalMessageComponent extends GlobalMessageComponent {}

